import script from "./SettingWarningBox.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingWarningBox.vue?vue&type=script&setup=true&lang=js"

import "./SettingWarningBox.vue?vue&type=style&index=0&id=36936a93&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36936a93"]])

export default __exports__